import { FormControlLabel, Switch } from '@mui/material';

import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { useChainSelectors } from '../ChainSelectorsProvider';
import { consensusSwitchTranslation } from './translation';
import { useConsensusSwitchStyles } from './useConsensusSwitchStyles';

interface ConsensusSwitchProps {
  className?: string;
}

export const ConsensusSwitch = ({ className }: ConsensusSwitchProps) => {
  const {
    consensus,
    consensusGroup,
    hasConsensusSwitch,
    isConsensusEnabled,
    setIsConsensusEnabled,
  } = useChainSelectors();

  const { classes } = useConsensusSwitchStyles();

  const { keys, t } = useTranslation(consensusSwitchTranslation);

  if (!consensusGroup || !hasConsensusSwitch) {
    return null;
  }

  const label = consensus === 'beacon' ? t(keys.beacon) : t(keys.opnode);

  return (
    <FormControlLabel
      className={className}
      classes={{
        root: classes.root,
        label: classes.label,
      }}
      control={
        <Switch
          checked={isConsensusEnabled}
          classes={{
            checked: classes.switchChecked,
            track: classes.switchTrack,
          }}
          onChange={() => setIsConsensusEnabled(!isConsensusEnabled)}
        />
      }
      label={label}
    />
  );
};
